export default __webpack_public_path__ + "static/media/drop.e1e7d8e9.svg";